import { useEffect, useState } from 'react';

import { useLazyQuery } from '@apollo/client';

import CommissionType from 'src/features/finance/commissionStatement/constants/commissionType';
import { CommissionFilter } from 'src/utils/tableUtils';

import { GET_COMMISSION_STATEMENT_FILTERS } from '../../../../graphql/queries/getCommissionStatements.query';
import { onError } from '../../../../utils/utils';

type UseCommissionStatementFiltersInput = {
    commissionType: CommissionType;
};

export const useCommissionStatementsFilters = ({
    commissionType,
}: UseCommissionStatementFiltersInput) => {
    const [idFilters, setIdFilters] = useState<CommissionFilter[]>();
    const [partnerNameFilters, setPartnerNamerFilters] = useState<string[]>();

    const [commissionStatemetsFilters] = useLazyQuery(GET_COMMISSION_STATEMENT_FILTERS, {
        fetchPolicy: 'network-only',
        onError: (error) => {
            return onError(error);
        },
        onCompleted: ({ commissionStatementFilters }) => {
            const { ids, partnerNames } = commissionStatementFilters;
            setIdFilters(ids);
            setPartnerNamerFilters(partnerNames);
        },
    });

    useEffect(() => {
        const fetchCommissionStatementFilters = async () => {
            await commissionStatemetsFilters({
                variables: {
                    commissionType,
                },
            });
        };
        fetchCommissionStatementFilters();
    }, [commissionStatemetsFilters, commissionType]);

    return {
        idFilters,
        partnerNameFilters,
    };
};

export default useCommissionStatementsFilters;
